import React, { Component } from 'react';
import { TextField } from 'rmwc/TextField';
import { Radio } from 'rmwc/Radio';
import {Button} from 'rmwc/Button';
import SerializeForm from 'form-serialize';
import * as api from '../api/api';
import StatusMessage from '../util/StatusMessage'

class PersonalInfo extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      save_disable: false,
      data:{
      first_name: '',
      last_name: '',
      gender_id: '',
      'dob': '',
      'aadharno': '',
      avatar: '',
      avatar_url: '',
      formataadharno: ''
      },
      componentState:{
        first_disable:false,
        last_disable:false,
        gender_disable:false,
        dob_disable:false,
        aadhar_disable:false,
        
      },
      formErrors:{
        aadharFormatError: '',
        firstNameError:''
      }
    };
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  componentDidMount(){
    var curr = this;
    let data = Object.assign({}, this.state.data);
    let componentState = Object.assign({}, this.state.componentState);
    api.getBasicProfile(this.props.user.accessToken).then(function(result){
      if (result.id) {
      data.id = result.user_id? result.user_id: '';
      data.first_name = result.first_name?result.first_name : '';
      data.last_name = result.last_name ?result.last_name: '';
      data.gender_id = result.gender_id ? result.gender_id: '';
      data.dob = result.dob ? result.dob : '';
      data.aadharno = result.aadharno ? result.aadharno : '';
      data.avatar = result.avatar? result.avatar : '';
      data.avatar_url = result.avatar_url? result.avatar_url: '';
      data.formataadharno = result.aadharno ? result.aadharno : '';
      //result.aadharno.replace(/\D/g, "").split(/(?:([\d]{4}))/g).filter(s => s.length > 0).join("-") : '';
      if(data.first_name != '')
        componentState.first_disable = true
      if(data.last_name != '')
        componentState.last_disable = true
      if(data.gender_id != '')
        componentState.gender_disable = true
      if(data.dob != '')
        componentState.dob_disable = true
      if(data.aadharno != '')
        componentState.aadhar_disable = true

      }
      curr.setState({data: data, componentState:componentState})
      })
  }

    validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    let componentState = Object.assign({}, this.state.componentState)
    errorObj.firstNameError = ''
    errorObj.aadharFormatError=''
    
    if(data.first_name === ''){
      errorObj.firstNameError ='First Name is mandatory'
      error = false
    }


    if(!this.state.componentState.aadhar_disable && this.state.data.aadharno.length > 0 && this.state.data.aadharno.length != 12){
      errorObj.aadharFormatError ='Please enter valid aadhar number'
       error = false
    }
     
    this.setState({
      formErrors:errorObj,
      errorMsg:''
    })
    return error
  }

  handleSubmit(e) {
    e.preventDefault()

    if(this.validateForm()){
      this.setState({save_disable: true})
      const formData = new FormData(e.target);
      api.saveBasicProfile(this.props.user.accessToken,formData)
      .then((result) => {
         const data = Object.assign({}, this.state.data);
         data.avatar_url = result.avatar_url;
         this.setState({data: data, save_disable:false});
         this.props.checkForChange(e, false)
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack, save_disable:false })
        this.props.checkForChange(e, false)
      })
    }
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
    this.props.checkForChange(evt,true)
  };

  onAadharChange = evt => {
    const data = Object.assign({}, this.state.data);
      let value = evt.target.value.replace(/\D/g, "").split(/(?:([\d]{4}))/g).filter(s => s.length > 0).join("-");
      data[evt.target.name] = value;
      data.aadharno = value.replace(/-/g, '');
      this.setState({data});
      this.props.checkForChange(evt, true)
  };

  render(){


    let genderComponent
    if(!this.state.componentState.gender_disable){
      genderComponent=(<div>Gender:
      <Radio
      name="gender_id"
      value="1"
      checked={this.state.data.gender_id == '1'}
      onChange={this.onInputChange}>
      Male
      </Radio>
      <Radio
      name="gender_id"
      value="2"
      checked={this.state.data.gender_id == '2'}
      onChange={this.onInputChange}>
      Female
      </Radio>
      <Radio
      name="gender_id"
      value="3"
      checked={this.state.data.gender_id == '3'}
      onChange={this.onInputChange}>
      Other
      </Radio>
      </div>)
    }
    else{
      genderComponent=(<div>Gender:
      <Radio
      name="gender_id"
      value="1"
      checked={this.state.data.gender_id == '1'}
      disabled
      onChange={this.onInputChange}>
      Male
      </Radio>
      <Radio
      name="gender_id"
      value="2"
      checked={this.state.data.gender_id == '2'}
      disabled
      onChange={this.onInputChange}>
      Female
      </Radio>
      <Radio
      name="gender_id"
      value="3"
      checked={this.state.data.gender_id == '3'}
      disabled
      onChange={this.onInputChange}>
      Other
      </Radio>
      </div>)
    }

    return <form  onSubmit={this.handleSubmit}>
    
    <div className="avatar hidden-div" >
    <img src= {this.state.data.avatar_url} />
    <label for="photoUpload" className="file-input btn btn-primary btn-block btn-outlined">Upload Photo</label>
    <input type="file" id="photoUpload" name="avatar"/>
     </div>
    <br/>
    <TextField label="User Name" autoComplete="off" disabled name="user_name" onChange={this.onInputChange} value={this.props.user.userName}/>

    <TextField label="First Name" autoComplete="off" name="first_name" onChange={this.onInputChange} value={this.state.data.first_name}/>
    <TextField label="Last Name" disabled={this.state.componentState.last_disable} autoComplete="off"  name="last_name" onChange={this.onInputChange} value={this.state.data.last_name}/>
    <br/>
    {genderComponent}
    <TextField type="date" disabled={this.state.componentState.dob_disable} className="datepicker-padding" label="Date Of Birth" autoComplete="off" name="dob" onChange={this.onInputChange} value={this.state.data.dob}/>
    <TextField label="Aadhar Number (for citizens of India)" disabled={this.state.componentState.aadhar_disable} autoComplete="off" name="formataadharno" onChange={this.onAadharChange} value={this.state.data.formataadharno}/>
    <Button raised disabled={this.state.save_disable}>Save</Button>
    <StatusMessage error_msg = {this.state.formErrors.aadharFormatError}/>
    <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
    <TextField hidden autoComplete="off" disabled={this.state.componentState.aadhar_disable} name="aadharno" value={this.state.data.aadharno}/>    
    </form>
  }
}

export default PersonalInfo;



// WEBPACK FOOTER //
// ./src/views/PersonalInfo.jsx